import { FunctionComponent, useEffect, useState } from 'react';

import {
  AutoplayControlConnected,
  ReBetControlConnected,
  TooltipPositions,
  UndoControlConnected,
  useGameStateSlice,
  Tooltip,
  useIsLargerThanWide,
  useIsPortrait,
  ChipStack,
  useMedia,
  useConfigSlice,
  useBonusBalanceConfig,
  useSettingsSlice
} from '@pp/core';
import { useNetPositionConnected } from '@pp/core/src/hooks/useNetPositionConnected';

import { useAllLimitConnected } from '../../hooks/useAllLimitConnected';
import styles from './rightControlsCell.module.css';

export const RightControlsCellConnected: FunctionComponent = () => {
  const [showVerticalChipStack, setShowVerticalChipStack] = useState(false);
  const isInFullscreen = useSettingsSlice.getIsInFullscreen();
  const isWide = useIsLargerThanWide();
  const isPortrait = useIsPortrait();
  const isBetsOpenStatus = useGameStateSlice.isBetsOpenStatus();
  const doubleBetTooltip = useAllLimitConnected();

  const compliance = useConfigSlice.compliance();
  const displayBonusBalance = useBonusBalanceConfig();
  const net = useNetPositionConnected();
  const isGameFooterInWideMode = useMedia('(min-width: 620px)');
  let isGameFooterExtended : boolean | undefined = false;
  if(isGameFooterInWideMode) {
    isGameFooterExtended = compliance?.showSessionTimer || compliance?.showSessionId; 
  } else {
    isGameFooterExtended = compliance?.showSessionTimer || displayBonusBalance || net !== undefined || compliance?.showSessionId; 
  }

  useEffect(() => {
    const handleChange = () => {
      const height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
      setShowVerticalChipStack(isGameFooterExtended ? height >= 370 : height >= 360);
    }
    handleChange();
    window.addEventListener('resize', handleChange);
    return () => {
      window.removeEventListener('resize', handleChange);
    };
  }, [isInFullscreen]);

  if (isWide) return null;

  return (
    <>
      {(!isPortrait && showVerticalChipStack) ? (
        <div 
          className={`${styles.rightControls__chipItem} ${styles.rightControls__item} ${!isBetsOpenStatus ? styles.rightControls__item_hidden : ''}`}
        >
          <ChipStack.Clip stacked="vertical" isChipStackDrawerClosed={!isBetsOpenStatus} />
        </div>
      ) : null}
      <div className={styles.rightControls}>
        {!isPortrait ? (
          <div className={`${styles.rightControls__item}`}>
            <UndoControlConnected />
          </div>
        ) : null}
        <div className={`${styles.rightControls__item}`}>
          <Tooltip text={doubleBetTooltip || ''} disabled={!doubleBetTooltip} position={TooltipPositions.Left}>
            <ReBetControlConnected />
          </Tooltip>
        </div>
        <div className={`${styles.rightControls__item} ${styles.rightControls__item_withIndicator}`}>
          <AutoplayControlConnected />
        </div>
      </div>
    </>
  );
};
